/** VIP Lounge gallery images — mirrors website/vip-service.php glob of images/vip_lounge/vip-lounge (*).jpg */

export const VIP_PHOTOS = Array.from({ length: 20 }, (_, i) => {
  const name = `vip-lounge (${i + 1}).jpg`;
  return {
    src: `/images/vip_lounge/${name}`,
    alt: `VIP Lounge at Nouakchott Oumtounsy International Airport (NKC/GQNO) — photo ${i + 1}`,
  };
});
